import React from "react";
import type { Outcome, ResearchLens } from "../../data/research";
import styles from "./OutcomeTile.module.css";

export function OutcomeTile({
  outcome,
  lens,
}: {
  outcome: Outcome;
  lens: ResearchLens;
}) {
  const provider = lens === "provider";
  return (
    <div className={`ui-card ${styles.tile}`}>
      <dt>
        <h3>{provider ? outcome.measure : outcome.result}</h3>
      </dt>
      <dd>{provider ? outcome.result : outcome.measure}</dd>
      <dd className={styles.p}>p = {outcome.p}</dd>
    </div>
  );
}
